export default "__VITE_ASSET__yR3gJtTd__"